import React from 'react'
import PropTypes from 'prop-types'
import { View, Text, StyleSheet } from 'react-native'
import { Swatch } from './swatch'
import { SwatchImage } from './swatch-image'
import { SwatchType, GroupMin } from '../types/swatch'
import { Group } from '../types/group'

function capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

type SwatchGroupProps = {
  /** The name of the group of options. */
  name: string,
  /** The type of swatch group. */
  type: string,
  /** The primary color of the component. */
  accentColor: string,
  /** The selected key of the swatch groups. */
  selected: number,
  /** The swatches to display. */
  swatches: SwatchType,
  /** The swatch has changed handler. */
  onSwatchChange: Function,
}

/**
 * A group of `Swatch`. Which is a group of options.
 * @component
 */
export class SwatchGroup extends React.Component<SwatchGroupProps> {
  static propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['basic', 'image']).isRequired,
    accentColor: PropTypes.string.isRequired,
    selected: PropTypes.number.isRequired,
    swatches: PropTypes.object.isRequired,
    onSwatchChange: PropTypes.func.isRequired,
  }

  onSwatchClick(key: number) {
    this.props.onSwatchChange(key, this.props.name)
  }

  render() {
    return (
      <View>
        <Text style={styles.groupLabel}>{capitalizeFirstLetter(this.props.name)}</Text>
        <View style={styles.swatchGroup}>
          {this.props?.swatches?.group?.map((swatch, key) => {
            if (this.props.type === 'basic') {
              return (
                <Swatch
                  accentColor={this.props.accentColor}
                  key={key}
                  keyID={key}
                  label={swatch.label}
                  // eslint-disable-next-line
                  selected={key == this.props.swatches.selected}
                  onSwatchClick={this.onSwatchClick.bind(this)}
                />
              )
            } else {
              return (
                <SwatchImage
                  accentColor={this.props.accentColor}
                  key={key}
                  keyID={key}
                  // eslint-disable-next-line
                  selected={key == this.props.swatches.selected}
                  onSwatchClick={this.onSwatchClick.bind(this)}
                  option={swatch.option}
                />
              )
            }
          })
          }
        </View>
      </View>
    )
  }
}

const styles = StyleSheet.create({
  swatchGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  groupLabel: {
    fontWeight: 'bold',
    margin: 10,
  },
})
